import { render, staticRenderFns } from "./SegmentsTable.vue?vue&type=template&id=49d4a322&scoped=true&lang=pug&"
import script from "./SegmentsTable.vue?vue&type=script&lang=js&"
export * from "./SegmentsTable.vue?vue&type=script&lang=js&"
import style0 from "./SegmentsTable.vue?vue&type=style&index=0&id=49d4a322&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d4a322",
  null
  
)

export default component.exports